import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import UnderConstructionOverlay from "./components/UnderConstructionBanner";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* All Sunstone Families routes - show under construction */}
          <Route path="/*" element={
            <LanguageProvider>
              <UnderConstructionOverlay />
              <Toaster position="top-right" richColors />
            </LanguageProvider>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
